'use client';

import { Box } from '@terra/ui-styled-system';
import Image from 'next/image';

export function CollaborationEmptyIllustration() {
  return (
    <Box position="relative" w="100px" h="76px" flexShrink={0} aria-hidden>
      <Image
        src="/images/collaboration-empty-state.png"
        alt=""
        fill
        unoptimized
        sizes="100px"
        style={{ objectFit: 'contain' }}
      />
    </Box>
  );
}
